<template>
    <formcom />
  </template>
  
  <script>
  import formcom from '@/components/FormCommun.vue';
  
    export default {
        name: "FormComVue",
        components: {
        formcom
        }
    }
  
  </script>
  